import { render } from "./B2bPageRecadvsEmits.vue?vue&type=template&id=575b5d70&scoped=true&lang=pug"
import script from "./B2bPageRecadvsEmits.vue?vue&type=script&lang=js"
export * from "./B2bPageRecadvsEmits.vue?vue&type=script&lang=js"

import "./B2bPageRecadvsEmits.vue?vue&type=style&index=0&id=575b5d70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575b5d70"]])

export default __exports__